/**
 * Hadiyah Make Your Own Hamper builder
 * Single-page step state. Persists to sessionStorage and revalidates against Shopify.
 */
(function () {
  var STORAGE_KEY = 'hadiyah_hamper_state';
  var STEP_ORDER = ['intro', 'packaging', 'hijabs', 'addons', 'personalize', 'review', 'complete'];
  var PROGRESS_STEPS = ['packaging', 'hijabs', 'addons', 'personalize', 'review'];

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var root = document.querySelector('[data-myoh-root]');
    if (!root) return;

    document.documentElement.classList.add('myoh-page');
    document.body.classList.add('myoh-page', 'hide-sticky-toolbar');
    function suppressThemeBottomBars() {
      document.querySelectorAll(
        '.clean-mobile-bottom-nav-section, .clean-mobile-bottom-nav, .clean-mobile-bottom-nav__offset, .section--toolbar-mobile, toolbar-mobile, .toolbar-mobile, .halo-sticky-toolbar-mobile, .halo-bottom-bar'
      ).forEach(function (el) {
        el.setAttribute('hidden', '');
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
      document.body.style.setProperty('--toolbar-mobile-height', '0px');
      document.body.style.setProperty('--clean-mobile-bottom-nav-height', '0px');
    }

    function suppressCoinsLauncher() {
      var selectors = [
        '#nector-loyalty-widget',
        '#nector-floating-widget',
        '#nectorRoot',
        '#nector-root',
        '.nector-floating-widget',
        '.nector-widget',
        '[data-nector-floating]',
        '.nector-launcher',
        '.nector-widget-launcher',
        '[id*="nector-floating"]',
        '[class*="nector-floating"]',
        '[class*="nector"][class*="launcher"]',
        '[class*="nector"][class*="Launcher"]',
        '[class*="NectorFloating"]',
        '[class*="nector-fab"]',
        'iframe[src*="nector"]',
        'iframe[src*="getnector"]'
      ];
      document.querySelectorAll(selectors.join(',')).forEach(hideNode);

      // Catch edge tabs that only say "Coins" (shadow / late-injected widgets)
      Array.prototype.forEach.call(document.body.querySelectorAll('*'), function (el) {
        if (!(el instanceof HTMLElement)) return;
        if (el.closest && el.closest('[data-myoh-root], .myoh-modal')) return;
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!/coins/i.test(text)) return;
        if (text.length > 24) return;
        if (el.children && el.children.length > 6) return;
        var style = window.getComputedStyle(el);
        if (style.position !== 'fixed' && style.position !== 'sticky') {
          var parent = el.parentElement;
          if (!parent) return;
          var ps = window.getComputedStyle(parent);
          if (ps.position !== 'fixed' && ps.position !== 'sticky') return;
          hideNode(parent);
          return;
        }
        hideNode(el);
      });
    }

    function hideNode(el) {
      if (!el || !el.style) return;
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('width', '0', 'important');
      el.style.setProperty('height', '0', 'important');
      el.style.setProperty('left', '-9999px', 'important');
      el.style.setProperty('top', '-9999px', 'important');
      el.style.setProperty('z-index', '-1', 'important');
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('hidden', '');
    }

    suppressThemeBottomBars();
    suppressCoinsLauncher();
    setTimeout(suppressThemeBottomBars, 0);
    setTimeout(suppressCoinsLauncher, 0);
    setTimeout(suppressThemeBottomBars, 500);
    setTimeout(suppressCoinsLauncher, 500);
    setTimeout(suppressCoinsLauncher, 2000);
    setTimeout(suppressCoinsLauncher, 5000);
    if (typeof MutationObserver !== 'undefined') {
      var barObserver = new MutationObserver(function () {
        suppressThemeBottomBars();
        suppressCoinsLauncher();
      });
      barObserver.observe(document.documentElement, { childList: true, subtree: true });
    }

    var config = parseJson(document.getElementById('MyohConfig') && document.getElementById('MyohConfig').textContent, {});
    var catalog = parseJson(document.getElementById('MyohCatalog') && document.getElementById('MyohCatalog').textContent, {
      packaging: [],
      hijabs: [],
      addons: []
    });

    var els = {
      progress: root.querySelector('[data-myoh-progress]'),
      progressBtns: root.querySelectorAll('[data-myoh-goto]'),
      stages: {
        intro: root.querySelector('[data-myoh-stage="intro"]'),
        builder: root.querySelector('[data-myoh-stage="builder"]'),
        complete: root.querySelector('[data-myoh-stage="complete"]')
      },
      steps: {
        packaging: root.querySelector('[data-myoh-step="packaging"]'),
        hijabs: root.querySelector('[data-myoh-step="hijabs"]'),
        addons: root.querySelector('[data-myoh-step="addons"]'),
        personalize: root.querySelector('[data-myoh-step="personalize"]'),
        review: root.querySelector('[data-myoh-step="review"]')
      },
      notice: root.querySelector('[data-myoh-notice]'),
      toast: root.querySelector('[data-myoh-toast]'),
      toastText: root.querySelector('[data-myoh-toast-text]'),
      modal: root.querySelector('[data-myoh-modal]'),
      modalTitle: root.querySelector('[data-myoh-modal-title]'),
      modalPrice: root.querySelector('[data-myoh-modal-price]'),
      modalDescription: root.querySelector('[data-myoh-modal-description]'),
      modalMain: root.querySelector('[data-myoh-modal-main]'),
      modalThumbs: root.querySelector('[data-myoh-modal-thumbs]'),
      modalVariantWrap: root.querySelector('[data-myoh-modal-variant-wrap]'),
      modalVariant: root.querySelector('[data-myoh-modal-variant]'),
      modalQtyValue: root.querySelector('[data-myoh-modal-qty-value]'),
      progressPersonalize: root.querySelector('[data-myoh-progress-personalize]'),
      action: root.querySelector('[data-myoh-action]'),
      actionItems: root.querySelector('[data-myoh-action-items]'),
      selectedSheet: root.querySelector('[data-myoh-selected]'),
      selectedList: root.querySelector('[data-myoh-selected-list]'),
      selectedTotal: root.querySelector('[data-myoh-selected-total]'),
      summaryItems: root.querySelector('[data-myoh-item-count]'),
      summaryTotal: root.querySelector('[data-myoh-total]'),
      back: root.querySelector('[data-myoh-back]'),
      next: root.querySelector('[data-myoh-next]'),
      review: root.querySelector('[data-myoh-review]'),
      personalize: root.querySelector('[data-myoh-personalize]'),
      completeBody: root.querySelector('[data-myoh-complete-body]')
    };

    var state = defaultState();
    var adding = false;
    var updatingBundle = false;
    var modalCard = null;
    var modalImages = [];
    var modalImageIndex = 0;
    var modalQty = 1;
    var myohCustomizerTarget = null;
    var productDetailCache = {};

    resolveSkuSlots()
      .then(function () {
        return restore();
      })
      .then(function () {
        bind();
        render();
      });

    function defaultState() {
      return {
        v: 5,
        step: 'packaging',
        hamperId: uid(),
        packaging: null,
        hijabs: [],
        addons: [],
        bundleQty: 1
      };
    }

    function uid() {
      return 'HYH-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
    }

    function parseJson(value, fallback) {
      try {
        return JSON.parse(value || '');
      } catch (e) {
        return fallback;
      }
    }

    function packagingRulesFromTitle(title) {
      var t = String(title || '').toLowerCase();
      if (t.indexOf('small pvc') >= 0 || t.indexOf('pvc bag') >= 0) {
        return { capacity: 2, totalCapacity: 5, accessoriesCapacity: 3, allowedExceptions: '' };
      }
      if (t.indexOf('8x8') >= 0 || t.indexOf('8 x 8') >= 0) {
        return { capacity: 4, totalCapacity: 6, accessoriesCapacity: 2, allowedExceptions: 'gypsy-flower' };
      }
      if (t.indexOf('eco friendly') >= 0 || t.indexOf('eco-friendly') >= 0) {
        return { capacity: 3, totalCapacity: 8, accessoriesCapacity: 5, allowedExceptions: '' };
      }
      if (t.indexOf('wooden tray') >= 0 || t.indexOf('wood tray') >= 0) {
        return { capacity: 6, totalCapacity: 9, accessoriesCapacity: 3, allowedExceptions: 'gypsy-flower' };
      }
      if (t.indexOf('black velvet') >= 0) {
        return { capacity: 12, totalCapacity: 14, accessoriesCapacity: 2, allowedExceptions: 'gypsy-flower,small-roses' };
      }
      if (t.indexOf('12.5 velvet') >= 0 || t.indexOf('12.5') >= 0 && t.indexOf('velvet') >= 0) {
        return { capacity: 3, totalCapacity: 11, accessoriesCapacity: 8, allowedExceptions: '' };
      }
      return {
        capacity: Number(config.defaultCapacity) || 6,
        totalCapacity: 0,
        accessoriesCapacity: 0,
        allowedExceptions: ''
      };
    }

    function normalizePackagingItem(item) {
      if (!item) return item;
      var rules = packagingRulesFromTitle(item.title || '');
      var next = Object.assign({}, item);
      var capacityValue = Number(next.capacity) || 0;
      var accessoriesValue = Number(next.accessoriesCapacity) || 0;
      var totalValue = Number(next.totalCapacity) || 0;

      if (!(capacityValue > 0)) capacityValue = rules.capacity;
      if (!(accessoriesValue > 0)) accessoriesValue = rules.accessoriesCapacity;
      if (!(accessoriesValue > 0) && totalValue > capacityValue) {
        accessoriesValue = totalValue - capacityValue;
      }
      // When both limits are known, total is always hijabs + accessories
      if (capacityValue > 0 && accessoriesValue > 0) {
        totalValue = capacityValue + accessoriesValue;
      } else if (!(totalValue > 0)) {
        totalValue = rules.totalCapacity || 0;
      }
      if (!String(next.allowedExceptions || '').trim()) {
        next.allowedExceptions = rules.allowedExceptions || '';
      }

      next.capacity = capacityValue;
      next.accessoriesCapacity = accessoriesValue;
      next.totalCapacity = totalValue;
      return next;
    }

    function packagingLimits() {
      if (!state.packaging) {
        return {
          capacity: Number(config.defaultCapacity) || 6,
          accessoriesCapacity: Number(config.maxAddons) || 8,
          totalCapacity: 0,
          allowedExceptions: ''
        };
      }
      return normalizePackagingItem(state.packaging);
    }

    function findVariantBySku(product, sku) {
      var target = String(sku || '').trim().toLowerCase();
      if (!product || !target) return null;
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].sku || '').trim().toLowerCase() === target) return variants[i];
      }
      return null;
    }

    function searchProductBySku(sku) {
      var query = String(sku || '').trim();
      if (!query) return Promise.resolve(null);
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=10&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .then(function (json) {
          var products = (((json || {}).resources || {}).results || {}).products || [];
          if (!products.length) return null;
          var handles = [];
          products.forEach(function (item) {
            if (item && item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
          });
          return Promise.all(handles.map(fetchProduct)).then(function (fullProducts) {
            for (var i = 0; i < fullProducts.length; i++) {
              var product = fullProducts[i];
              if (product && findVariantBySku(product, query)) return product;
            }
            return fullProducts[0] || null;
          });
        })
        .catch(function () {
          return null;
        });
    }

    function buildCardHtml(product, role, preferredSku, capacityOverrides) {
      var rules = packagingRulesFromTitle(product.title);
      var overrides = capacityOverrides || {};
      if (Number(overrides.hijabCapacity) > 0) rules.capacity = Number(overrides.hijabCapacity);
      if (Number(overrides.accessoriesCapacity) > 0) rules.accessoriesCapacity = Number(overrides.accessoriesCapacity);
      if (Number(overrides.hijabCapacity) > 0 && Number(overrides.accessoriesCapacity) > 0) {
        rules.totalCapacity = Number(overrides.hijabCapacity) + Number(overrides.accessoriesCapacity);
      }
      var variant = findVariantBySku(product, preferredSku) ||
        (product.variants || []).find(function (v) { return v.available; }) ||
        (product.variants || [])[0];
      if (!variant) return '';

      var image = '';
      if (variant.featured_image) {
        image = variant.featured_image.src || variant.featured_image;
      } else if (product.featured_image) {
        image = product.featured_image;
      }

      var meta = '';
      if (role === 'packaging') {
        meta += '<span class="myoh-card__meta">Up to ' + rules.capacity + ' hijabs · ' + rules.accessoriesCapacity + ' accessories</span>';
      }
      if (variant.sku) {
        meta += '<span class="myoh-card__meta">SKU: ' + escapeHtml(variant.sku) + '</span>';
      }

      var options = '';
      if ((product.variants || []).length > 1) {
        options = '<label class="myoh-card__variant"><span class="visually-hidden">Choose option</span><select data-myoh-variant>';
        (product.variants || []).forEach(function (v) {
          var vImage = v.featured_image ? (v.featured_image.src || v.featured_image) : image;
          options += '<option value="' + v.id + '"' +
            ' data-price="' + (v.price || 0) + '"' +
            ' data-compare="' + (v.compare_at_price || 0) + '"' +
            ' data-available="' + (v.available !== false) + '"' +
            ' data-image="' + escapeHtml(vImage || '') + '"' +
            ' data-title="' + escapeHtml(v.title || '') + '"' +
            ' data-sku="' + escapeHtml(v.sku || '') + '"' +
            (v.available === false ? ' disabled' : '') +
            (String(v.id) === String(variant.id) ? ' selected' : '') +
            '>' + escapeHtml(v.title || 'Default') +
            (v.sku ? ' · ' + escapeHtml(v.sku) : '') +
            '</option>';
        });
        options += '</select></label>';
      }

      return (
        '<article class="myoh-card' + (product.available === false ? ' is-unavailable' : '') + '"' +
          ' data-myoh-card' +
          ' data-role="' + escapeHtml(role) + '"' +
          ' data-product-id="' + product.id + '"' +
          ' data-handle="' + escapeHtml(product.handle) + '"' +
          ' data-variant-id="' + variant.id + '"' +
          ' data-title="' + escapeHtml(product.title) + '"' +
          ' data-price="' + (variant.price || 0) + '"' +
          ' data-compare="' + (variant.compare_at_price || 0) + '"' +
          ' data-image="' + escapeHtml(image || '') + '"' +
          ' data-capacity="' + rules.capacity + '"' +
          ' data-available="' + (product.available !== false) + '"' +
          ' data-url="/products/' + escapeHtml(product.handle) + '"' +
          ' data-total-capacity="' + rules.totalCapacity + '"' +
          ' data-accessories-capacity="' + rules.accessoriesCapacity + '"' +
          ' data-allowed-exceptions="' + escapeHtml(rules.allowedExceptions) + '"' +
          ' data-exception-key=""' +
          ' data-sku="' + escapeHtml(variant.sku || '') + '"' +
          ' data-description="' + escapeHtml(stripHtml(product.body_html || product.description || '')) + '"' +
          ' data-personalizable="' + ((product.tags || []).some(function (tag) {
            return String(tag || '').toLowerCase().indexOf('personaliz') >= 0;
          }) ? 'true' : 'false') + '"' +
          ' data-image-list="' + escapeHtml(((product.images || []).map(function (img) {
            return typeof img === 'string' ? img : (img.src || '');
          }).filter(Boolean).join('|')) || image || '') + '">' +
          '<span class="myoh-card__media" data-myoh-open-detail role="button" tabindex="0" aria-label="View details for ' + escapeHtml(product.title) + '">' +
            (image
              ? '<img class="myoh-card__img" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
              : '<span class="myoh-card__placeholder"></span>') +
            '<span class="myoh-card__check" aria-hidden="true">✓</span>' +
          '</span>' +
          '<span class="myoh-card__body">' +
            '<span class="myoh-card__title">' + escapeHtml(product.title) + '</span>' +
            '<span class="myoh-card__price" data-myoh-card-price>' + formatMoney(variant.price || 0) + '</span>' +
            meta +
          '</span>' +
          options +
          '<button type="button" class="myoh-card__add" data-myoh-select aria-pressed="false"' +
            (product.available === false ? ' disabled' : '') +
          '>Add</button>' +
          '<div class="myoh-card__qty" data-myoh-qty hidden>' +
            '<button type="button" data-myoh-qty-minus aria-label="Decrease quantity">−</button>' +
            '<span data-myoh-qty-value>1</span>' +
            '<button type="button" data-myoh-qty-plus aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</article>'
      );
    }

    function pushCatalogProduct(role, product) {
      if (!product || !product.handle) return;
      catalog[role] = catalog[role] || [];
      var exists = catalog[role].some(function (item) {
        return item && item.handle === product.handle;
      });
      if (exists) return;
      catalog[role].push({
        id: product.id,
        handle: product.handle,
        title: product.title,
        description: stripHtml(product.body_html || product.description || ''),
        personalizable: (product.tags || []).some(function (tag) {
          return String(tag || '').toLowerCase().indexOf('personaliz') >= 0;
        }),
        available: product.available !== false,
        capacity: packagingRulesFromTitle(product.title).capacity,
        total_capacity: packagingRulesFromTitle(product.title).totalCapacity,
        accessories_capacity: packagingRulesFromTitle(product.title).accessoriesCapacity,
        featured_image: product.featured_image || null,
        images: (product.images || []).map(function (img) {
          return typeof img === 'string' ? img : (img.src || '');
        }),
        variants: (product.variants || []).map(function (v) {
          return {
            id: v.id,
            title: v.title,
            available: v.available !== false,
            price: v.price,
            compare_at_price: v.compare_at_price || 0,
            featured_image: v.featured_image ? (v.featured_image.src || v.featured_image) : null,
            sku: v.sku || ''
          };
        })
      });
    }

    function resolveSkuSlots() {
      var slots = Array.prototype.slice.call(root.querySelectorAll('[data-myoh-sku-slot]'));
      if (!slots.length) return Promise.resolve();
      return Promise.all(slots.map(function (slot) {
        var sku = slot.getAttribute('data-sku');
        var role = slot.getAttribute('data-role') || 'packaging';
        var capacityOverrides = {
          hijabCapacity: Number(slot.getAttribute('data-hijab-capacity')) || 0,
          accessoriesCapacity: Number(slot.getAttribute('data-accessories-capacity')) || 0
        };
        return searchProductBySku(sku).then(function (product) {
          if (!product) {
            slot.classList.add('is-error');
            slot.innerHTML = '<p class="myoh-sku-slot__label">No product found for SKU ' + escapeHtml(sku) + '</p>';
            return;
          }
          var html = buildCardHtml(product, role, sku, capacityOverrides);
          if (!html) {
            slot.classList.add('is-error');
            slot.innerHTML = '<p class="myoh-sku-slot__label">SKU ' + escapeHtml(sku) + ' has no usable variant</p>';
            return;
          }
          slot.outerHTML = html;
          pushCatalogProduct(role, product);
        });
      }));
    }

    function formatMoney(cents) {
      var amount = Number(cents) || 0;
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(amount, window.money_format || config.moneyFormat);
      }
      var rupees = (amount / 100).toFixed(0);
      return '₹' + Number(rupees).toLocaleString('en-IN');
    }

    function save() {
      try {
        var payload = {
          v: state.v,
          step: state.step === 'complete' ? 'intro' : state.step,
          hamperId: state.hamperId,
          packaging: state.packaging,
          hijabs: state.hijabs,
          addons: state.addons,
          bundleQty: state.bundleQty || 1
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } catch (e) {}
    }

    function restore() {
      var stored;
      try {
        stored = parseJson(sessionStorage.getItem(STORAGE_KEY), null);
      } catch (e) {
        stored = null;
      }
      if (!stored || (stored.v !== 4 && stored.v !== 5)) return Promise.resolve();
      state.step = STEP_ORDER.indexOf(stored.step) >= 0 ? stored.step : 'packaging';
      if (state.step === 'complete' || state.step === 'intro' || state.step === 'pins') state.step = 'packaging';
      state.hamperId = stored.hamperId || state.hamperId;
      state.bundleQty = stored.bundleQty || 1;
      return revalidate(stored).then(function (next) {
        state.packaging = next.packaging;
        state.hijabs = next.hijabs;
        state.addons = next.addons;
        enforceCapacity(true);
        if (!state.packaging && ['hijabs', 'addons', 'personalize', 'review'].indexOf(state.step) >= 0) {
          state.step = 'packaging';
        }
        if (state.packaging && qtyOf(state.hijabs) < 1 && ['addons', 'personalize', 'review'].indexOf(state.step) >= 0) {
          state.step = 'hijabs';
        }
        if (state.step === 'personalize' && !shouldShowPersonalizeStep()) state.step = 'review';
        save();
      });
    }

    function findCatalogProduct(handle) {
      var lists = ['packaging', 'hijabs', 'addons'];
      for (var i = 0; i < lists.length; i++) {
        var list = catalog[lists[i]] || [];
        for (var j = 0; j < list.length; j++) {
          if (list[j].handle === handle) return list[j];
        }
      }
      return null;
    }

    function fetchProduct(handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      }).then(function (res) {
        if (!res.ok) return null;
        return res.json();
      }).catch(function () {
        return null;
      });
    }

    function hydrateItem(item, product) {
      if (!item || !product) return null;
      var variant = (product.variants || []).find(function (v) {
        return String(v.id) === String(item.variantId);
      });
      if (!variant || variant.available === false) {
        variant = (product.variants || []).find(function (v) { return v.available; });
      }
      if (!variant) return null;
      var image = variant.featured_image
        ? (variant.featured_image.src || variant.featured_image)
        : product.featured_image;
      var rules = packagingRulesFromTitle(product.title || item.title);
      var role = item.role;
      var capacityValue = Number(product.capacity) || Number(item.capacity) || 0;
      var totalCapacityValue = Number(product.total_capacity) || Number(item.totalCapacity) || 0;
      var accessoriesCapacityValue = Number(product.accessories_capacity) || Number(item.accessoriesCapacity) || 0;
      var allowedExceptionsValue = product.allowed_exceptions || item.allowedExceptions || '';
      if (role === 'packaging') {
        if (!capacityValue) capacityValue = rules.capacity;
        if (!totalCapacityValue) totalCapacityValue = rules.totalCapacity;
        if (!accessoriesCapacityValue) accessoriesCapacityValue = rules.accessoriesCapacity;
        if (!String(allowedExceptionsValue).trim() && rules.allowedExceptions) {
          allowedExceptionsValue = rules.allowedExceptions;
        }
      }
      return {
        productId: product.id,
        handle: product.handle,
        variantId: variant.id,
        title: product.title,
        variantTitle: variant.title && variant.title !== 'Default Title' ? variant.title : '',
        price: Number(variant.price) || 0,
        compare: Number(variant.compare_at_price) || 0,
        image: image || item.image || '',
        qty: Math.max(1, Number(item.qty) || 1),
        role: role,
        available: true,
        capacity: capacityValue,
        totalCapacity: totalCapacityValue,
        accessoriesCapacity: accessoriesCapacityValue,
        allowedExceptions: allowedExceptionsValue,
        exceptionKey: product.exception_key || item.exceptionKey || '',
        mock: !!item.mock || !!product.mock,
        personalizable: !!item.personalizable || !!product.personalizable,
        customization: item.customization || null,
        description: item.description || product.description || '',
        imageList: item.imageList || ''
      };
    }

    function revalidate(stored) {
      var items = [];
      if (stored.packaging) items.push(stored.packaging);
      (stored.hijabs || []).forEach(function (item) { items.push(item); });
      (stored.addons || []).forEach(function (item) { items.push(item); });

      var uniqueHandles = [];
      items.forEach(function (item) {
        if (item && !item.mock && item.handle && uniqueHandles.indexOf(item.handle) === -1) {
          uniqueHandles.push(item.handle);
        }
      });

      return Promise.all(
        uniqueHandles.map(function (handle) {
          var local = findCatalogProduct(handle);
          if (local) return Promise.resolve(local);
          return fetchProduct(handle);
        })
      ).then(function (products) {
        var byHandle = {};
        uniqueHandles.forEach(function (handle, index) {
          if (products[index]) byHandle[handle] = products[index];
        });

        function revive(item) {
          if (!item) return null;
          if (item.mock) return item;
          return hydrateItem(item, byHandle[item.handle]);
        }

        return {
          packaging: stored.packaging ? normalizePackagingItem(revive(stored.packaging)) : null,
          hijabs: (stored.hijabs || []).map(revive).filter(Boolean),
          addons: (stored.addons || []).map(revive).filter(Boolean)
        };
      });
    }

    function capacity() {
      return packagingLimits().capacity;
    }

    function accessoriesCapacity() {
      var limits = packagingLimits();
      if (limits.accessoriesCapacity > 0) return limits.accessoriesCapacity;
      return Number(config.maxAddons) || 8;
    }

    function contentCapacity() {
      var limits = packagingLimits();
      if (limits.totalCapacity > 0) return limits.totalCapacity;
      if (limits.capacity > 0 && limits.accessoriesCapacity > 0) {
        return limits.capacity + limits.accessoriesCapacity;
      }
      return 0;
    }

    function qtyOf(list) {
      return (list || []).reduce(function (sum, item) {
        return sum + (Number(item.qty) || 0);
      }, 0);
    }

    function contentQty() {
      return qtyOf(state.hijabs) + qtyOf(state.addons);
    }

    function packagingLocksAfterHijabLimit() {
      return String(packagingLimits().allowedExceptions || '').trim() !== '';
    }

    function allowedAfterHijabLimit(item) {
      var allowed = packagingLimits().allowedExceptions;
      if (!allowed || !item || !item.exceptionKey) return false;
      return String(allowed)
        .toLowerCase()
        .split(',')
        .map(function (value) { return value.trim(); })
        .filter(Boolean)
        .indexOf(String(item.exceptionKey).toLowerCase()) >= 0;
    }

    function constraintMessage(item) {
      var maxContents = contentCapacity();
      var maxAccessories = accessoriesCapacity();
      var addonQty = qtyOf(state.addons);
      var hijabQty = qtyOf(state.hijabs);

      if (item && item.role === 'hijabs') {
        return 'Add a maximum of ' + capacity() + ' hijabs to continue';
      }

      if (item && item.role === 'addons') {
        if (addonQty < maxAccessories && maxContents > 0 && contentQty() >= maxContents) {
          return 'Add a maximum of ' + maxContents + ' products to continue';
        }
        if (addonQty >= maxAccessories) {
          if (packagingLocksAfterHijabLimit() && hijabQty >= capacity()) {
            return 'Accessory slots are full. Only allowed finishing items can be added now.';
          }
          return 'Add a maximum of ' + maxAccessories + ' accessories to continue';
        }
        return 'Add a maximum of ' + maxAccessories + ' accessories to continue';
      }

      if (maxContents > 0 && contentQty() >= maxContents) {
        return 'Add a maximum of ' + maxContents + ' products to continue';
      }
      return 'Add a maximum of ' + absoluteMaxFor(item && item.role ? item.role : 'addons') + ' products to continue';
    }

    function isPersonalizableFlag(value) {
      return String(value || '').trim().toLowerCase() === 'true';
    }

    function personalizableItems() {
      return collectItems().filter(function (item) { return item.personalizable; });
    }

    function pendingPersonalization() {
      return personalizableItems().filter(function (item) {
        return !item.customization || !item.customization.id;
      });
    }

    function shouldShowPersonalizeStep() {
      return personalizableItems().length > 0;
    }

    function nextStepAfter(step) {
      var index = STEP_ORDER.indexOf(step);
      var next = STEP_ORDER[index + 1];
      if (next === 'personalize' && !shouldShowPersonalizeStep()) {
        return STEP_ORDER[index + 2];
      }
      return next;
    }

    function prevStepBefore(step) {
      var index = STEP_ORDER.indexOf(step);
      var prev = STEP_ORDER[index - 1];
      if (prev === 'personalize' && !shouldShowPersonalizeStep()) {
        return STEP_ORDER[index - 2];
      }
      return prev;
    }

    function canAddItem(item, quantity) {
      var amount = Number(quantity) || 1;
      if (!item || amount < 1) return true;
      if (item.role === 'packaging') return true;

      var hijabQty = qtyOf(state.hijabs);
      var addonQty = qtyOf(state.addons);
      var maxHijabs = capacity();
      var maxAccessories = accessoriesCapacity();
      var maxContents = contentCapacity();

      if (item.role === 'hijabs') {
        if (hijabQty + amount > maxHijabs) return false;
        if (maxContents > 0 && hijabQty + addonQty + amount > maxContents) return false;
        return true;
      }

      if (item.role === 'addons') {
        var withinAccessorySlots = addonQty + amount <= maxAccessories;
        var withinTotal = maxContents <= 0 || hijabQty + addonQty + amount <= maxContents;

        // Normal accessories are always allowed while slots remain
        if (withinAccessorySlots && withinTotal) return true;

        // Past accessory limit: only packaging exception items (e.g. finishing flowers)
        if (
          hijabQty >= maxHijabs &&
          packagingLocksAfterHijabLimit() &&
          allowedAfterHijabLimit(item)
        ) {
          return true;
        }

        return false;
      }

      return true;
    }

    function itemCount() {
      var count = qtyOf(state.hijabs) + qtyOf(state.addons);
      if (state.packaging) count += Number(state.packaging.qty) || 1;
      return count;
    }

    function totalCents() {
      var total = 0;
      if (state.packaging) total += (Number(state.packaging.price) || 0) * (state.packaging.qty || 1);
      state.hijabs.forEach(function (item) { total += item.price * item.qty; });
      state.addons.forEach(function (item) { total += item.price * item.qty; });
      return total;
    }

    function absoluteMaxFor(role) {
      if (role === 'hijabs') return capacity();
      if (role === 'addons') return accessoriesCapacity();
      return 1;
    }

    function maxFor(role) {
      if (role === 'hijabs') {
        var maxHijabs = capacity();
        var maxContents = contentCapacity();
        if (maxContents > 0) {
          return Math.min(maxHijabs, Math.max(0, maxContents - qtyOf(state.addons)));
        }
        return maxHijabs;
      }
      if (role === 'addons') {
        var maxAccessories = accessoriesCapacity();
        var maxContents = contentCapacity();
        if (maxContents > 0) {
          return Math.min(maxAccessories, Math.max(0, maxContents - qtyOf(state.hijabs)));
        }
        return maxAccessories;
      }
      return 1;
    }

    function listFor(role) {
      if (role === 'packaging') return state.packaging ? [state.packaging] : [];
      return state[role] || [];
    }

    function enforceCapacity(silent) {
      var maxHijabs = capacity();
      var maxAccessories = accessoriesCapacity();
      var hijabQty = qtyOf(state.hijabs);
      var addonQty = qtyOf(state.addons);
      var changed = false;

      if (hijabQty > maxHijabs) {
        trimList('hijabs', maxHijabs);
        changed = true;
        if (!silent) {
          showNotice('Your packaging holds up to ' + maxHijabs + ' hijabs. Extra hijabs were removed.');
        }
      }

      if (addonQty > maxAccessories) {
        trimList('addons', maxAccessories);
        changed = true;
        if (!silent) {
          showNotice('Your packaging holds up to ' + maxAccessories + ' accessories. Extra accessories were removed.');
        }
      }

      var maxContents = contentCapacity();
      if (maxContents > 0 && contentQty() > maxContents) {
        var remaining = maxContents;
        ['hijabs', 'addons'].forEach(function (role) {
          var keep = Math.max(0, remaining);
          var before = qtyOf(state[role]);
          trimList(role, keep);
          remaining -= qtyOf(state[role]);
          if (qtyOf(state[role]) !== before) changed = true;
        });
        if (!silent && changed) {
          showNotice('Your packaging holds up to ' + maxContents + ' items in total. Extra items were removed.');
        }
      }

      if (state.packaging) {
        state.packaging = normalizePackagingItem(state.packaging);
      }
    }

    function trimList(role, maxQty) {
      var kept = [];
      var remaining = maxQty;
      (state[role] || []).forEach(function (item) {
        if (remaining <= 0) return;
        var next = Object.assign({}, item);
        next.qty = Math.min(next.qty, remaining);
        remaining -= next.qty;
        kept.push(next);
      });
      state[role] = kept;
    }

    function cardToItem(card) {
      var select = card.querySelector('[data-myoh-variant]');
      var option = select && select.selectedOptions ? select.selectedOptions[0] : null;
      var variantId = option ? option.value : card.getAttribute('data-variant-id');
      var price = option ? option.getAttribute('data-price') : card.getAttribute('data-price');
      var image = option && option.getAttribute('data-image')
        ? option.getAttribute('data-image')
        : card.getAttribute('data-image');
      var variantTitle = option ? option.getAttribute('data-title') : '';
      var available = option
        ? option.getAttribute('data-available') !== 'false'
        : card.getAttribute('data-available') !== 'false';
      if (!available) return null;
      return {
        productId: card.getAttribute('data-product-id'),
        handle: card.getAttribute('data-handle'),
        variantId: variantId,
        title: card.getAttribute('data-title'),
        variantTitle: variantTitle && variantTitle !== 'Default Title' ? variantTitle : '',
        price: Number(price) || 0,
        compare: Number(option ? option.getAttribute('data-compare') : card.getAttribute('data-compare')) || 0,
        image: image || '',
        qty: 1,
        role: card.getAttribute('data-role'),
        available: true,
        capacity: Number(card.getAttribute('data-capacity')) || 0,
        totalCapacity: Number(card.getAttribute('data-total-capacity')) || 0,
        accessoriesCapacity: Number(card.getAttribute('data-accessories-capacity')) || 0,
        allowedExceptions: card.getAttribute('data-allowed-exceptions') || '',
        exceptionKey: card.getAttribute('data-exception-key') || '',
        mock: card.getAttribute('data-mock') === 'true',
        personalizable: isPersonalizableFlag(card.getAttribute('data-personalizable')),
        description: card.getAttribute('data-description') || '',
        imageList: card.getAttribute('data-image-list') || ''
      };
    }

    function findItemInState(item) {
      if (!item) return null;
      if (item.role === 'packaging') {
        return state.packaging && sameItem(state.packaging, item) ? state.packaging : null;
      }
      var list = state[item.role] || [];
      return list.find(function (entry) { return sameItem(entry, item); }) || null;
    }

    function applyCustomizationToItem(item, customization) {
      if (!item || !customization) return;
      var target = findItemInState(item);
      if (target) target.customization = customization;
    }

    function sameItem(a, b) {
      return a && b && String(a.variantId) === String(b.variantId);
    }

    function toggleSelect(card) {
      var item = cardToItem(card);
      if (!item) return;
      var role = item.role;
      if (role === 'packaging') {
        if (state.packaging && sameItem(state.packaging, item)) {
          state.packaging = null;
        } else {
          state.packaging = normalizePackagingItem(item);
          enforceCapacity(false);
        }
        save();
        render();
        return;
      }
      var list = state[role] || [];
      var index = list.findIndex(function (entry) { return sameItem(entry, item); });
      if (index >= 0) {
        list.splice(index, 1);
      } else {
        if (!canAddItem(item, 1)) {
          showCapacityToast(constraintMessage(item));
          save();
          render();
          return;
        }
        var newItem = Object.assign({}, item);
        list.push(newItem);
      }
      state[role] = list;
      hideCapacityToast();
      hideNotice();
      save();
      render();
    }

    function changeQty(card, delta) {
      var item = cardToItem(card);
      if (!item) return;
      var role = item.role;
      if (role === 'packaging') return;
      var list = state[role] || [];
      var entry = list.find(function (row) { return sameItem(row, item); });
      if (!entry) return;
      var nextQty = entry.qty + delta;
      if (nextQty < 1) {
        state[role] = list.filter(function (row) { return !sameItem(row, item); });
      } else {
        if (delta > 0 && !canAddItem(item, delta)) {
          showCapacityToast(constraintMessage(item));
          return;
        }
        entry.qty = nextQty;
      }
      hideNotice();
      save();
      render();
    }

    function setStep(step) {
      if (STEP_ORDER.indexOf(step) < 0) return;
      if (!canVisit(step)) return;
      state.step = step;
      save();
      render();
      var target = step === 'intro'
        ? els.stages.intro
        : step === 'complete'
          ? els.stages.complete
          : root.querySelector('[data-myoh-builder]');
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function canVisit(step) {
      if (step === 'intro' || step === 'complete') return true;
      var index = STEP_ORDER.indexOf(step);
      var current = STEP_ORDER.indexOf(state.step);
      if (index <= current) return true;
      if (step === 'hijabs') return !!state.packaging;
      if (step === 'addons' || step === 'personalize' || step === 'review') {
        return !!state.packaging && qtyOf(state.hijabs) >= 1;
      }
      return true;
    }

    function canGoNext() {
      if (state.step === 'packaging') return !!state.packaging;
      if (state.step === 'hijabs') return qtyOf(state.hijabs) >= 1;
      if (state.step === 'personalize') return pendingPersonalization().length === 0;
      return true;
    }

    function nextLabel() {
      if (state.step === 'intro') return config.startLabel || 'Start Building';
      if (state.step === 'packaging') return config.continueLabel || 'Continue';
      if (state.step === 'personalize') return config.nextLabel || 'Next →';
      if (state.step === 'review') return config.addLabel || 'Add Hamper to Cart';
      return config.nextLabel || 'Next →';
    }

    function goNext() {
      if (state.step === 'intro') {
        setStep('packaging');
        return;
      }
      if (state.step === 'review') {
        addToCart();
        return;
      }
      if (!canGoNext()) {
        if (state.step === 'packaging') showNotice('Please choose your hamper packaging to continue.', true);
        if (state.step === 'hijabs') showNotice('Please choose at least one hijab for this hamper.', true);
        if (state.step === 'personalize') {
          showNotice('Please personalize all marked items before continuing.', true);
        }
        return;
      }
      var next = nextStepAfter(state.step);
      if (next) setStep(next);
    }

    function goBack() {
      if (state.step === 'packaging') {
        return;
      }
      var prev = prevStepBefore(state.step);
      if (prev) setStep(prev);
    }

    function showNotice(message, isError) {
      if (!els.notice) return;
      els.notice.hidden = false;
      els.notice.textContent = message;
      els.notice.classList.toggle('is-error', !!isError);
    }

    function hideNotice() {
      if (!els.notice) return;
      els.notice.hidden = true;
      els.notice.textContent = '';
      els.notice.classList.remove('is-error');
    }

    function showCapacityToast(message) {
      if (els.toast && els.toastText) {
        els.toastText.textContent = message;
        els.toast.hidden = false;
        root.classList.add('is-toast-open');
        return;
      }
      showNotice(message, true);
    }

    function hideCapacityToast() {
      if (!els.toast) return;
      els.toast.hidden = true;
      root.classList.remove('is-toast-open');
    }

    function propertiesFor(item) {
      var props = {
        '_hamper_id': state.hamperId,
        'Hamper': 'Make Your Own Hamper',
        '_Role': item.role === 'addons' ? 'Accessories' : capitalize(item.role)
      };
      if (item.role === 'packaging') props['_hamper_host'] = 'true';
      if (item.customization && item.customization.properties) {
        Object.keys(item.customization.properties).forEach(function (key) {
          if (key && item.customization.properties[key] != null && item.customization.properties[key] !== '') {
            props[key] = item.customization.properties[key];
          }
        });
      }
      return props;
    }

    function capitalize(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    }

    function collectItems() {
      var items = [];
      if (state.packaging) items.push(state.packaging);
      state.hijabs.forEach(function (item) { items.push(item); });
      state.addons.forEach(function (item) { items.push(item); });
      return items;
    }

    function cartEndpoint(kind) {
      var url = kind === 'update'
        ? (config.cartUpdateUrl || '/cart/update')
        : kind === 'add'
          ? (config.cartAddUrl || '/cart/add')
          : (config.cartUrl || '/cart');
      return String(url).replace(/\.js$/i, '') + '.js';
    }

    function refreshThemeCart() {
      return fetch(cartEndpoint('cart'), {
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Unable to refresh your bag.');
          return res.json();
        })
        .then(function (cart) {
          if (!Array.isArray(cart.items) || !Number.isFinite(cart.item_count) ||
              !Number.isFinite(cart.total_price) || typeof cart.currency !== 'string') {
            throw new Error('Unable to refresh your bag.');
          }
          if (window.CleanCartState && typeof window.CleanCartState.publish === 'function') {
            window.CleanCartState.publish(cart);
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          document.dispatchEvent(new CustomEvent('clean:cart:updated', { detail: { cart: cart } }));
          return cart;
        })
        .catch(function () { return null; });
    }

    function updateHamperCartQuantity(nextQty) {
      var hamperId = state.hamperId;
      var qty = Math.max(0, Number(nextQty) || 0);
      return fetch(cartEndpoint('cart'), { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var currentHostQty = 1;
          var lines = (cart.items || []).filter(function (item) {
            return String((item.properties || {})._hamper_id || '') === String(hamperId);
          });
          if (!lines.length) return cart;
          lines.forEach(function (item) {
            if (String((item.properties || {})._hamper_host || '').toLowerCase() === 'true') {
              currentHostQty = Math.max(1, Number(item.quantity) || 1);
            }
          });
          var cleanCommerce = window['clean-commerce'];
          var cleanBefore = cleanCommerce?.snapshot(cart);
          var updates = {};
          lines.forEach(function (item) {
            var base = Math.max(1, Math.round((Number(item.quantity) || 1) / currentHostQty));
            updates[item.key] = qty <= 0 ? 0 : base * qty;
          });
          return fetch(cartEndpoint('update'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ updates: updates })
          }).then(function (res) {
            return res.json().then(function (json) {
              if (!res.ok) throw new Error(json.description || json.message || 'Unable to update bag.');
              cleanCommerce?.changed(cleanBefore, json, 'legacy-hamper', undefined, lines.map(function (line) { return line.variant_id || line.id; }));
              return json;
            });
          });
        })
        .then(function (cart) {
          if (window.CleanCartState && typeof window.CleanCartState.publish === 'function') {
            window.CleanCartState.publish(cart);
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
          return cart;
        });
    }

    function addToCart() {
      if (adding) return;
      if (!state.packaging) {
        showNotice('Please choose your hamper packaging to continue.', true);
        return;
      }
      if (qtyOf(state.hijabs) < 1) {
        showNotice('Please choose at least one hijab for this hamper.', true);
        return;
      }
      if (pendingPersonalization().length) {
        showNotice('Please personalize all marked items before adding to cart.', true);
        setStep('personalize');
        return;
      }
      if (collectItems().some(function (item) { return item.mock; })) {
        showNotice(
          'Demo packaging cannot be added to your bag. Add real packaging products in the theme editor (Make Your Own Hamper → Packaging product blocks), then choose one of those boxes.',
          true
        );
        return;
      }
      adding = true;
      var purchaseConfirmed = false;
      if (els.next) {
        els.next.disabled = true;
        els.next.textContent = config.addingLabel || 'Adding…';
      }
      var payload = {
        items: collectItems().map(function (item) {
          return {
            id: Number(item.variantId),
            quantity: Number(item.qty) || 1,
            properties: propertiesFor(item)
          };
        })
      };
      return fetch(cartEndpoint('add'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Clean-Cart': 'true'
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().then(function (json) {
            return { ok: res.ok, json: json };
          });
        })
        .then(function (result) {
          if (!result.ok || result.json.errors || result.json.status === 422) {
            var message = result.json.description || result.json.message || result.json.errors || 'We could not add this hamper to your bag. Please try again.';
            throw new Error(typeof message === 'string' ? message : 'We could not add this hamper to your bag. Please try again.');
          }
          window['clean-commerce']?.added(result.json, payload.items, 'legacy-hamper');
          purchaseConfirmed = true;
          state.bundleQty = 1;
          try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
          // Review is the final step — add to cart, open bag, reset builder (no separate complete step)
          state = defaultState();
          return refreshThemeCart().then(function (cart) {
            render();
            return openBag(cart);
          });
        })
        .catch(function (error) {
          showNotice(purchaseConfirmed
            ? 'Your hamper was added. Please open your bag to view it.'
            : error.message || 'We could not add this hamper to your bag. Please try again.', true);
        })
        .finally(function () {
          adding = false;
          render();
        });
    }

    function openBag(cart) {
      var drawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
      if (drawer && typeof drawer.renderCartJson === 'function') {
        return drawer.renderCartJson(cart).then(function (rendered) {
          if (!rendered) throw new Error('Unable to refresh your bag.');
          return rendered;
        });
      }
      if (window.CleanCart && typeof window.CleanCart.openDrawer === 'function') {
        return window.CleanCart.openDrawer({ refresh: true });
      }
      if (drawer && typeof drawer.open === 'function') {
        return drawer.open();
      }
      window.location.href = config.cartUrl || '/cart';
    }

    function startAgain() {
      state = defaultState();
      save();
      render();
      if (els.stages.intro) {
        els.stages.intro.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (els.stages.builder) {
        els.stages.builder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function editBundle() {
      if (updatingBundle) return;
      updatingBundle = true;
      updateHamperCartQuantity(0)
        .then(function () {
          updatingBundle = false;
          state.bundleQty = 1;
          state.step = 'review';
          save();
          render();
        })
        .catch(function (error) {
          updatingBundle = false;
          showNotice(error.message || 'Unable to edit this hamper.', true);
        });
    }

    function removeBundle() {
      if (updatingBundle) return;
      updatingBundle = true;
      updateHamperCartQuantity(0)
        .then(function () {
          updatingBundle = false;
          startAgain();
        })
        .catch(function (error) {
          updatingBundle = false;
          showNotice(error.message || 'Unable to remove this hamper.', true);
        });
    }

    function setBundleQty(nextQty) {
      var qty = Math.max(1, Number(nextQty) || 1);
      if (qty === (state.bundleQty || 1) || updatingBundle) return;
      updatingBundle = true;
      updateHamperCartQuantity(qty)
        .then(function () {
          state.bundleQty = qty;
          updatingBundle = false;
          renderComplete();
        })
        .catch(function (error) {
          updatingBundle = false;
          showNotice(error.message || 'Unable to update quantity.', true);
          renderComplete();
        });
    }

    function renderComplete() {
      if (!els.completeBody || state.step !== 'complete') return;
      var items = collectItems();
      var qty = Math.max(1, Number(state.bundleQty) || 1);
      var count = items.reduce(function (sum, item) { return sum + (Number(item.qty) || 1); }, 0);
      var unitTotal = totalCents();
      var lineRows = items.map(function (item) {
        var lineQty = Number(item.qty) || 1;
        var lineTotal = (Number(item.price) || 0) * lineQty * qty;
        return (
          '<li class="myoh-bag-review__line">' +
            '<span class="myoh-bag-review__line-title">' + escapeHtml(item.title) + '</span>' +
            '<span class="myoh-bag-review__line-price">' + formatMoney(lineTotal) + ' x' + (lineQty * qty) + '</span>' +
          '</li>'
        );
      }).join('');

      els.completeBody.innerHTML =
        '<div class="myoh-bag-review__layout">' +
          '<article class="myoh-bag-review__bundle">' +
            '<div class="myoh-bag-review__bundle-top">' +
              '<div class="myoh-bag-review__icon" aria-hidden="true">' +
                '<svg viewBox="0 0 48 48" fill="none">' +
                  '<path d="M8 16h32l-2 24H10L8 16Z" stroke="currentColor" stroke-width="2"/>' +
                  '<path d="M8 16l4-8h24l4 8" stroke="currentColor" stroke-width="2"/>' +
                  '<path d="M24 8v8" stroke="currentColor" stroke-width="2"/>' +
                '</svg>' +
              '</div>' +
              '<div class="myoh-bag-review__bundle-main">' +
                '<div class="myoh-bag-review__bundle-heading">' +
                  '<h3 class="myoh-bag-review__bundle-title">Make Your Own Hamper <span>' + count + ' Item(s)</span></h3>' +
                  '<div class="myoh-bag-review__bundle-meta">' +
                    '<strong class="myoh-bag-review__bundle-total">' + formatMoney(unitTotal * qty) + ' x' + qty + '</strong>' +
                    '<div class="myoh-bag-review__bundle-actions">' +
                      '<button type="button" class="myoh-bag-review__edit" data-myoh-edit-bundle>Edit</button>' +
                      '<button type="button" class="myoh-bag-review__remove" data-myoh-remove-bundle>Remove</button>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
                '<div class="myoh-bag-review__qty" data-myoh-bundle-qty>' +
                  '<button type="button" aria-label="Decrease quantity" data-myoh-bundle-minus' + (qty <= 1 ? ' disabled' : '') + '>-</button>' +
                  '<input type="number" min="1" step="1" value="' + qty + '" aria-label="Hamper quantity" data-myoh-bundle-input>' +
                  '<button type="button" aria-label="Increase quantity" data-myoh-bundle-plus>+</button>' +
                '</div>' +
              '</div>' +
            '</div>' +
            '<ul class="myoh-bag-review__lines">' + lineRows + '</ul>' +
          '</article>' +
          '<aside class="myoh-bag-review__summary">' +
            '<h3>Order Details</h3>' +
            '<div class="myoh-bag-review__summary-row">' +
              '<span>Subtotal</span>' +
              '<strong>' + formatMoney(unitTotal * qty) + '</strong>' +
            '</div>' +
            '<button type="button" class="myoh-bag-review__checkout" data-myoh-checkout>Checkout</button>' +
            '<button type="button" class="myoh-bag-review__new" data-myoh-again>Create new Box</button>' +
          '</aside>' +
        '</div>';
    }

    function goCheckout() {
      return Promise.resolve().then(function () { return openBag(); }).catch(function () {
        showNotice('Unable to open your bag. Please try again.', true);
      });
    }

    function stripHtml(html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html || '';
      return (tmp.textContent || tmp.innerText || '').trim();
    }

    function catalogProductForHandle(handle) {
      var roles = ['packaging', 'hijabs', 'addons'];
      for (var i = 0; i < roles.length; i++) {
        var list = catalog[roles[i]] || [];
        var found = list.find(function (p) { return p && p.handle === handle; });
        if (found) return found;
      }
      return null;
    }

    function fetchProductDetails(handle) {
      if (!handle || String(handle).indexOf('mock-') === 0) {
        return Promise.resolve(null);
      }
      if (productDetailCache[handle]) return Promise.resolve(productDetailCache[handle]);
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (product) {
          if (product) productDetailCache[handle] = product;
          return product;
        })
        .catch(function () { return null; });
    }

    function imagesForCard(card, productDetails) {
      if (productDetails && productDetails.images && productDetails.images.length) {
        return productDetails.images.map(function (img) {
          return typeof img === 'string' ? img : (img.src || '');
        }).filter(Boolean);
      }
      var list = String(card.getAttribute('data-image-list') || '').split('|').filter(Boolean);
      if (list.length) return list;
      var single = card.getAttribute('data-image');
      return single ? [single] : [];
    }

    function renderModalGallery() {
      if (!els.modalMain || !els.modalThumbs) return;
      var prevBtn = root.querySelector('[data-myoh-modal-prev]');
      var nextBtn = root.querySelector('[data-myoh-modal-next]');
      var showNav = modalImages.length > 1;

      if (prevBtn) prevBtn.hidden = !showNav;
      if (nextBtn) nextBtn.hidden = !showNav;
      if (els.modalThumbs) els.modalThumbs.hidden = !showNav;

      if (!modalImages.length) {
        els.modalMain.innerHTML = '<div class="myoh-modal__placeholder"></div>';
        els.modalThumbs.innerHTML = '';
        return;
      }
      modalImageIndex = Math.max(0, Math.min(modalImageIndex, modalImages.length - 1));
      els.modalMain.innerHTML = '<img src="' + escapeHtml(modalImages[modalImageIndex]) + '" alt="">';
      if (!showNav) {
        els.modalThumbs.innerHTML = '';
        return;
      }
      els.modalThumbs.innerHTML = modalImages.map(function (src, index) {
        return '<button type="button" class="myoh-modal__thumb' + (index === modalImageIndex ? ' is-active' : '') + '" data-myoh-modal-thumb="' + index + '">' +
          '<img src="' + escapeHtml(src) + '" alt="">' +
        '</button>';
      }).join('');
    }

    function syncModalFromCard(card) {
      if (!card || !els.modal) return;
      modalCard = card;
      modalQty = Math.max(1, selectedQty(card) || 1);
      if (els.modalQtyValue) els.modalQtyValue.textContent = String(modalQty);
      if (els.modalTitle) els.modalTitle.textContent = card.getAttribute('data-title') || '';
      if (els.modalPrice) els.modalPrice.innerHTML = formatMoney(Number(card.getAttribute('data-price')) || 0);

      var handle = card.getAttribute('data-handle');
      var description = card.getAttribute('data-description') || '';
      var catalogProduct = catalogProductForHandle(handle);
      if (catalogProduct && catalogProduct.description) description = catalogProduct.description;
      if (els.modalDescription) {
        els.modalDescription.textContent = description || '';
      }

      fetchProductDetails(handle).then(function (product) {
        if (modalCard !== card) return;
        modalImages = imagesForCard(card, product);
        if (product && product.description) {
          description = stripHtml(product.description);
        } else if (product && product.body_html) {
          description = stripHtml(product.body_html);
        }
        if (els.modalDescription) {
          els.modalDescription.textContent = description || 'No description available for this product yet.';
        }
        renderModalGallery();
      });

      if (els.modalVariantWrap && els.modalVariant) {
        var cardSelect = card.querySelector('[data-myoh-variant]');
        if (cardSelect && cardSelect.options.length > 1) {
          els.modalVariantWrap.hidden = false;
          els.modalVariant.innerHTML = cardSelect.innerHTML;
          els.modalVariant.value = cardSelect.value;
        } else {
          els.modalVariantWrap.hidden = true;
        }
      }

      var selected = isSelected(card);
      var addBtn = els.modal.querySelector('[data-myoh-modal-add]');
      if (addBtn) addBtn.textContent = selected ? 'Update Box' : 'Add To Box';
    }

    function openDetailModal(card) {
      if (!els.modal || !card) return;
      syncModalFromCard(card);
      /* Mount on body so fixed + vertical centering aren't trapped by section transforms */
      if (els.modal.parentElement !== document.body) {
        document.body.appendChild(els.modal);
      }
      els.modal.hidden = false;
      els.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('myoh-modal-open');
      suppressCoinsLauncher();
    }

    function closeDetailModal() {
      if (!els.modal) return;
      els.modal.hidden = true;
      els.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('myoh-modal-open');
      modalCard = null;
    }

    function addFromModal() {
      if (!modalCard) return;
      var card = modalCard;
      var item = cardToItem(card);
      if (!item) return;
      var role = item.role;
      if (role === 'packaging') {
        state.packaging = normalizePackagingItem(item);
        enforceCapacity(false);
        save();
        render();
        closeDetailModal();
        return;
      }
      var list = state[role] || [];
      var entry = list.find(function (row) { return sameItem(row, item); });
      if (entry) {
        if (modalQty < 1) {
          state[role] = list.filter(function (row) { return !sameItem(row, item); });
        } else {
          var delta = modalQty - entry.qty;
          if (delta > 0 && !canAddItem(item, delta)) {
            showCapacityToast(constraintMessage(item));
            return;
          }
          entry.qty = modalQty;
        }
      } else {
        if (!canAddItem(item, modalQty)) {
          showCapacityToast(constraintMessage(item));
          return;
        }
        item.qty = modalQty;
        list.push(item);
      }
      state[role] = list;
      hideCapacityToast();
      hideNotice();
      save();
      render();
      closeDetailModal();
    }

    function openCustomizerForItem(item) {
      if (!item) return;
      var host = root.querySelector('[data-myoh-customizer-host][data-myoh-customizer-product-id="' + item.productId + '"]');
      if (!host) {
        showNotice('Customization is not available for this product yet.', true);
        return;
      }
      var customizer = host.querySelector('[data-hg-pdp-customizer]');
      if (!customizer) {
        showNotice('Customization is not available for this product yet.', true);
        return;
      }
      customizer.setAttribute('data-variant-id', String(item.variantId));
      if (item.variantTitle) customizer.setAttribute('data-variant-sku', item.sku || '');
      myohCustomizerTarget = item;
      window.__myohCustomizerVariantId = String(item.variantId);
      var openBtn = customizer.querySelector('[data-hg-open-customizer], [data-hg-open-customize]');
      if (openBtn) {
        openBtn.click();
        return;
      }
      showNotice('Unable to open the customizer for this item.', true);
    }

    function renderPersonalize() {
      if (!els.personalize || state.step !== 'personalize') return;
      var items = personalizableItems();
      if (!items.length) {
        els.personalize.innerHTML = '<p class="myoh-personalize__empty">No personalizable items in your hamper.</p>';
        return;
      }
      els.personalize.innerHTML = items.map(function (item) {
        var done = item.customization && item.customization.id;
        return (
          '<article class="myoh-personalize__item">' +
            (item.image ? '<img class="myoh-personalize__img" src="' + escapeHtml(item.image) + '" alt="">' : '') +
            '<div class="myoh-personalize__body">' +
              '<h3>' + escapeHtml(item.title) + '</h3>' +
              '<p>' + (done ? 'Personalized' : 'Add your personal touch to this item') + '</p>' +
              '<button type="button" class="myoh-personalize__btn" data-myoh-personalize-item="' + escapeHtml(String(item.variantId)) + '">' +
                (done ? 'Edit personalization' : 'Personalize') +
              '</button>' +
            '</div>' +
          '</article>'
        );
      }).join('');
    }

    function removeSelectedItem(variantId) {
      var id = String(variantId || '');
      if (state.packaging && String(state.packaging.variantId) === id) {
        // Packaging stays required — skip remove from selected sheet.
        return;
      }
      ['hijabs', 'addons'].forEach(function (role) {
        state[role] = (state[role] || []).filter(function (item) {
          return String(item.variantId) !== id;
        });
      });
      hideNotice();
      save();
      render();
      if (!collectItems().length) closeSelectedSheet();
    }

    function openSelectedSheet() {
      if (!els.selectedSheet) return;
      renderSelectedSheet();
      els.selectedSheet.hidden = false;
      els.selectedSheet.setAttribute('aria-hidden', 'false');
      document.body.classList.add('myoh-selected-open');
    }

    function closeSelectedSheet() {
      if (!els.selectedSheet) return;
      els.selectedSheet.hidden = true;
      els.selectedSheet.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('myoh-selected-open');
    }

    function renderSelectedSheet() {
      if (!els.selectedList) return;
      var items = collectItems();
      if (!items.length) {
        els.selectedList.innerHTML = '<p class="myoh-selected__empty">No products selected yet.</p>';
      } else {
        els.selectedList.innerHTML = items.map(function (item) {
          var canRemove = item.role !== 'packaging';
          return (
            '<article class="myoh-selected__row">' +
              '<div class="myoh-selected__media">' +
                (item.image
                  ? '<img src="' + escapeHtml(item.image) + '" alt="">'
                  : '<span class="myoh-selected__placeholder"></span>') +
                (canRemove
                  ? '<button type="button" class="myoh-selected__remove" data-myoh-remove-selected="' +
                    escapeHtml(String(item.variantId)) +
                    '" aria-label="Remove ' + escapeHtml(item.title) + '">×</button>'
                  : '') +
              '</div>' +
              '<div class="myoh-selected__info">' +
                '<span class="myoh-selected__title">' + escapeHtml(item.title) + '</span>' +
                '<span class="myoh-selected__price">x' + (Number(item.qty) || 1) + ' <strong>' +
                  formatMoney((Number(item.price) || 0) * (Number(item.qty) || 1)) +
                '</strong></span>' +
              '</div>' +
            '</article>'
          );
        }).join('');
      }
      if (els.selectedTotal) els.selectedTotal.innerHTML = formatMoney(totalCents());
    }

    function renderActionItems() {
      // Kept for compatibility; selected products now live in the sheet.
      if (els.actionItems) {
        els.actionItems.hidden = true;
        els.actionItems.innerHTML = '';
      }
      if (els.selectedSheet && !els.selectedSheet.hidden) {
        renderSelectedSheet();
      }
    }

    function bind() {
      root.addEventListener('click', function (event) {
        var start = event.target.closest('[data-myoh-start]');
        if (start) {
          event.preventDefault();
          setStep('packaging');
          return;
        }
        var goto = event.target.closest('[data-myoh-goto]');
        if (goto && !goto.disabled) {
          event.preventDefault();
          setStep(goto.getAttribute('data-myoh-goto'));
          return;
        }
        if (event.target.closest('[data-myoh-open-selected]')) {
          event.preventDefault();
          openSelectedSheet();
          return;
        }
        if (event.target.closest('[data-myoh-selected-close]')) {
          event.preventDefault();
          closeSelectedSheet();
          return;
        }
        var removeSelected = event.target.closest('[data-myoh-remove-selected]');
        if (removeSelected) {
          event.preventDefault();
          removeSelectedItem(removeSelected.getAttribute('data-myoh-remove-selected'));
          return;
        }
        if (event.target.closest('[data-myoh-toast-close]')) {
          event.preventDefault();
          hideCapacityToast();
          return;
        }
        if (event.target.closest('[data-myoh-modal-close]')) {
          event.preventDefault();
          closeDetailModal();
          return;
        }
        if (event.target.closest('[data-myoh-modal-prev]')) {
          event.preventDefault();
          modalImageIndex = Math.max(0, modalImageIndex - 1);
          renderModalGallery();
          return;
        }
        if (event.target.closest('[data-myoh-modal-next]')) {
          event.preventDefault();
          modalImageIndex = Math.min(modalImages.length - 1, modalImageIndex + 1);
          renderModalGallery();
          return;
        }
        if (event.target.closest('[data-myoh-modal-thumb]')) {
          event.preventDefault();
          modalImageIndex = Number(event.target.closest('[data-myoh-modal-thumb]').getAttribute('data-myoh-modal-thumb')) || 0;
          renderModalGallery();
          return;
        }
        if (event.target.closest('[data-myoh-modal-qty-minus]')) {
          event.preventDefault();
          modalQty = Math.max(1, modalQty - 1);
          if (els.modalQtyValue) els.modalQtyValue.textContent = String(modalQty);
          return;
        }
        if (event.target.closest('[data-myoh-modal-qty-plus]')) {
          event.preventDefault();
          if (modalCard) {
            var modalItem = cardToItem(modalCard);
            if (modalItem && !canAddItem(modalItem, 1)) {
              showCapacityToast(constraintMessage(modalItem));
              return;
            }
          }
          modalQty += 1;
          if (els.modalQtyValue) els.modalQtyValue.textContent = String(modalQty);
          return;
        }
        if (event.target.closest('[data-myoh-modal-add]')) {
          event.preventDefault();
          addFromModal();
          return;
        }
        if (event.target.closest('[data-myoh-checkout]')) {
          event.preventDefault();
          goCheckout();
          return;
        }
        var personalizeBtn = event.target.closest('[data-myoh-personalize-item]');
        if (personalizeBtn) {
          event.preventDefault();
          var variantId = personalizeBtn.getAttribute('data-myoh-personalize-item');
          var target = personalizableItems().find(function (item) {
            return String(item.variantId) === String(variantId);
          });
          openCustomizerForItem(target);
          return;
        }
        var openDetail = event.target.closest('[data-myoh-open-detail]');
        if (openDetail) {
          event.preventDefault();
          event.stopPropagation();
          var detailCard = openDetail.closest('[data-myoh-card]');
          if (detailCard) openDetailModal(detailCard);
          return;
        }
        var select = event.target.closest('[data-myoh-select]');
        if (select) {
          event.preventDefault();
          var card = select.closest('[data-myoh-card]');
          if (card) toggleSelect(card);
          return;
        }
        var minus = event.target.closest('[data-myoh-qty-minus]');
        if (minus) {
          event.preventDefault();
          changeQty(minus.closest('[data-myoh-card]'), -1);
          return;
        }
        var plus = event.target.closest('[data-myoh-qty-plus]');
        if (plus) {
          event.preventDefault();
          changeQty(plus.closest('[data-myoh-card]'), 1);
          return;
        }
        var edit = event.target.closest('[data-myoh-edit]');
        if (edit) {
          event.preventDefault();
          setStep(edit.getAttribute('data-myoh-edit'));
          return;
        }
        if (event.target.closest('[data-myoh-back]')) {
          event.preventDefault();
          goBack();
          return;
        }
        if (event.target.closest('[data-myoh-next]')) {
          event.preventDefault();
          goNext();
          return;
        }
        if (event.target.closest('[data-myoh-skip]')) {
          event.preventDefault();
          var index = STEP_ORDER.indexOf(state.step);
          setStep(STEP_ORDER[index + 1]);
          return;
        }
        if (event.target.closest('[data-myoh-view-bag]')) {
          event.preventDefault();
          goCheckout();
          return;
        }
        if (event.target.closest('[data-myoh-edit-bundle]')) {
          event.preventDefault();
          editBundle();
          return;
        }
        if (event.target.closest('[data-myoh-remove-bundle]')) {
          event.preventDefault();
          removeBundle();
          return;
        }
        if (event.target.closest('[data-myoh-bundle-minus]')) {
          event.preventDefault();
          setBundleQty((state.bundleQty || 1) - 1);
          return;
        }
        if (event.target.closest('[data-myoh-bundle-plus]')) {
          event.preventDefault();
          setBundleQty((state.bundleQty || 1) + 1);
          return;
        }
        if (event.target.closest('[data-myoh-again]')) {
          event.preventDefault();
          startAgain();
        }
      });

      /* Modal is moved to document.body, so clicks no longer bubble through root */
      if (els.modal) {
        els.modal.addEventListener('click', function (event) {
          if (event.target.closest('[data-myoh-modal-close]')) {
            event.preventDefault();
            closeDetailModal();
            return;
          }
          if (event.target.closest('[data-myoh-modal-prev]')) {
            event.preventDefault();
            modalImageIndex = Math.max(0, modalImageIndex - 1);
            renderModalGallery();
            return;
          }
          if (event.target.closest('[data-myoh-modal-next]')) {
            event.preventDefault();
            modalImageIndex = Math.min(modalImages.length - 1, modalImageIndex + 1);
            renderModalGallery();
            return;
          }
          if (event.target.closest('[data-myoh-modal-thumb]')) {
            event.preventDefault();
            modalImageIndex = Number(event.target.closest('[data-myoh-modal-thumb]').getAttribute('data-myoh-modal-thumb')) || 0;
            renderModalGallery();
            return;
          }
          if (event.target.closest('[data-myoh-modal-qty-minus]')) {
            event.preventDefault();
            modalQty = Math.max(1, modalQty - 1);
            if (els.modalQtyValue) els.modalQtyValue.textContent = String(modalQty);
            return;
          }
          if (event.target.closest('[data-myoh-modal-qty-plus]')) {
            event.preventDefault();
            if (modalCard) {
              var modalItem = cardToItem(modalCard);
              if (modalItem && !canAddItem(modalItem, 1)) {
                showCapacityToast(constraintMessage(modalItem));
                return;
              }
            }
            modalQty += 1;
            if (els.modalQtyValue) els.modalQtyValue.textContent = String(modalQty);
            return;
          }
          if (event.target.closest('[data-myoh-modal-add]')) {
            event.preventDefault();
            addFromModal();
          }
        });

        els.modal.addEventListener('change', function (event) {
          var modalVariant = event.target.closest('[data-myoh-modal-variant]');
          if (!modalVariant || !modalCard) return;
          var cardSelect = modalCard.querySelector('[data-myoh-variant]');
          if (cardSelect) {
            cardSelect.value = modalVariant.value;
            cardSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
          syncModalFromCard(modalCard);
        });
      }

      root.addEventListener('change', function (event) {
        var bundleInput = event.target.closest('[data-myoh-bundle-input]');
        if (bundleInput) {
          setBundleQty(bundleInput.value);
          return;
        }
        var modalVariant = event.target.closest('[data-myoh-modal-variant]');
        if (modalVariant && modalCard) {
          var cardSelect = modalCard.querySelector('[data-myoh-variant]');
          if (cardSelect) {
            cardSelect.value = modalVariant.value;
            cardSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
          syncModalFromCard(modalCard);
          return;
        }
        var select = event.target.closest('[data-myoh-variant]');
        if (!select) return;
        var card = select.closest('[data-myoh-card]');
        if (!card) return;
        var option = select.selectedOptions[0];
        if (!option) return;
        card.setAttribute('data-variant-id', option.value);
        card.setAttribute('data-price', option.getAttribute('data-price') || '0');
        card.setAttribute('data-compare', option.getAttribute('data-compare') || '0');
        var image = option.getAttribute('data-image');
        if (image) {
          card.setAttribute('data-image', image);
          var img = card.querySelector('.myoh-card__img');
          if (img) img.src = image;
        }
        var priceEl = card.querySelector('[data-myoh-card-price]');
        if (priceEl) {
          var html = formatMoney(option.getAttribute('data-price'));
          var compare = Number(option.getAttribute('data-compare')) || 0;
          var price = Number(option.getAttribute('data-price')) || 0;
          if (compare > price) html += ' <s>' + formatMoney(compare) + '</s>';
          priceEl.innerHTML = html;
        }
        var role = card.getAttribute('data-role');
        if (role === 'packaging' && state.packaging && String(state.packaging.productId) === card.getAttribute('data-product-id')) {
          state.packaging = normalizePackagingItem(cardToItem(card));
          save();
          render();
        }
      });

      document.addEventListener('myoh:customization-complete', function (event) {
        var detail = event.detail || {};
        if (!myohCustomizerTarget || String(detail.variantId) !== String(myohCustomizerTarget.variantId)) return;
        applyCustomizationToItem(myohCustomizerTarget, {
          id: detail.customizationId || detail.id || uid(),
          properties: detail.properties || {}
        });
        myohCustomizerTarget = null;
        window.__myohCustomizerVariantId = '';
        save();
        render();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (els.selectedSheet && !els.selectedSheet.hidden) {
          closeSelectedSheet();
          return;
        }
        if (els.modal && !els.modal.hidden) {
          closeDetailModal();
        }
      });
    }

    function isSelected(card) {
      var role = card.getAttribute('data-role');
      var variantId = card.getAttribute('data-variant-id');
      var list = listFor(role);
      return list.some(function (item) { return String(item.variantId) === String(variantId); });
    }

    function selectedQty(card) {
      var role = card.getAttribute('data-role');
      var variantId = card.getAttribute('data-variant-id');
      var entry = listFor(role).find(function (item) { return String(item.variantId) === String(variantId); });
      return entry ? entry.qty : 0;
    }

    function renderCards() {
      root.querySelectorAll('[data-myoh-card]').forEach(function (card) {
        var selected = isSelected(card);
        card.classList.toggle('is-selected', selected);
        var button = card.querySelector('[data-myoh-select]');
        if (button) {
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          button.textContent = selected ? 'Added' : 'Add';
        }
        var qtyWrap = card.querySelector('[data-myoh-qty]');
        var qtyValue = card.querySelector('[data-myoh-qty-value]');
        var role = card.getAttribute('data-role');
        if (qtyWrap) {
          var showQty = selected && role !== 'packaging';
          qtyWrap.hidden = !showQty;
          if (qtyValue) qtyValue.textContent = String(selectedQty(card) || 1);
        }
      });
    }

    function renderProgress() {
      var showPersonalize = shouldShowPersonalizeStep();
      var visibleSteps = showPersonalize
        ? PROGRESS_STEPS.slice()
        : PROGRESS_STEPS.filter(function (step) { return step !== 'personalize'; });
      var currentIndex = visibleSteps.indexOf(state.step);
      var stepNumber = 0;

      if (els.progressPersonalize) {
        els.progressPersonalize.hidden = !showPersonalize;
      }

      root.querySelectorAll('.myoh-progress__item').forEach(function (item) {
        if (item.hidden) return;
        stepNumber += 1;
        var num = item.querySelector('.myoh-progress__num');
        if (num) num.textContent = String(stepNumber);
      });

      els.progressBtns.forEach(function (btn) {
        var step = btn.getAttribute('data-myoh-goto');
        var item = btn.closest('.myoh-progress__item');
        if (!step) return;
        var index = visibleSteps.indexOf(step);
        var complete = index >= 0 && isStepComplete(step) && index < currentIndex;
        var active = state.step === step;
        var reachable = canVisit(step) && state.step !== 'intro' && state.step !== 'complete';
        if (item) {
          item.classList.toggle('is-active', active);
          item.classList.toggle('is-complete', complete);
        }
        btn.disabled = !reachable && !active;
      });

      scrollProgressToActive();
    }

    function scrollProgressToActive() {
      var list = root.querySelector('.myoh-progress__list');
      var active = root.querySelector('.myoh-progress__item.is-active');
      if (!list || !active || active.hidden) return;

      var listRect = list.getBoundingClientRect();
      var itemRect = active.getBoundingClientRect();
      var target =
        list.scrollLeft +
        (itemRect.left - listRect.left) -
        (listRect.width - itemRect.width) / 2;

      if (typeof list.scrollTo === 'function') {
        list.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      } else {
        list.scrollLeft = Math.max(0, target);
      }
    }

    function isStepComplete(step) {
      if (step === 'packaging') return !!state.packaging;
      if (step === 'hijabs') return qtyOf(state.hijabs) > 0;
      if (step === 'addons') return true;
      if (step === 'personalize') return pendingPersonalization().length === 0;
      if (step === 'review') return false;
      return false;
    }

    function renderCount() {
      var countEl = els.steps[state.step] && els.steps[state.step].querySelector('[data-myoh-count]');
      if (!countEl) return;
      if (state.step === 'hijabs') {
        countEl.hidden = false;
        countEl.textContent = qtyOf(state.hijabs) + ' of ' + absoluteMaxFor('hijabs') + ' hijabs selected';
        countEl.classList.toggle('is-full', qtyOf(state.hijabs) >= absoluteMaxFor('hijabs'));
      } else if (state.step === 'addons') {
        countEl.hidden = false;
        countEl.textContent = qtyOf(state.addons) + ' of ' + absoluteMaxFor('addons') + ' accessories selected';
        countEl.classList.toggle('is-full', qtyOf(state.addons) >= absoluteMaxFor('addons'));
      } else {
        countEl.hidden = true;
      }
    }

    function reviewGroup(title, items, step) {
      var rows = (items || []).map(function (item) {
        var subtitle = (item.variantTitle ? item.variantTitle + ' · ' : '') + 'Qty ' + item.qty;
        return (
          '<div class="myoh-review__row">' +
            (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="">' : '<span></span>') +
            '<p>' + escapeHtml(item.title) + '<small>' + escapeHtml(subtitle) + '</small></p>' +
            '<span>' + formatMoney(item.price * item.qty) + '</span>' +
          '</div>'
        );
      }).join('');
      return (
        '<div class="myoh-review__group">' +
          '<h3>' + escapeHtml(title) + ' <button type="button" class="myoh-review__edit" data-myoh-edit="' + step + '">Edit</button></h3>' +
          (rows
            ? '<div class="myoh-review__items">' + rows + '</div>'
            : '<p class="myoh-review__empty">None added — you can still continue.</p>') +
        '</div>'
      );
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function renderReview() {
      if (!els.review) return;
      if (state.step !== 'review') return;
      els.review.innerHTML =
        reviewGroup('Packaging', state.packaging ? [state.packaging] : [], 'packaging') +
        reviewGroup('Hijabs', state.hijabs, 'hijabs') +
        reviewGroup('Accessories', state.addons, 'addons') +
        '<p class="myoh-review__total">Hamper total ' + formatMoney(totalCents()) + '</p>';
    }

    function render() {
      var isIntro = state.step === 'intro';
      var isComplete = state.step === 'complete';
      var isBuilder = !isIntro && !isComplete;

      root.classList.toggle('is-intro', isIntro);
      root.classList.toggle('is-complete', isComplete);
      root.classList.toggle('is-builder', isBuilder);
      root.setAttribute('data-step', state.step);

      if (els.stages.intro) els.stages.intro.hidden = !isIntro;
      if (els.stages.builder) els.stages.builder.hidden = !isBuilder;
      if (els.stages.complete) els.stages.complete.hidden = !isComplete;
      if (els.progress) els.progress.hidden = !isBuilder;
      if (els.action) els.action.hidden = !isBuilder;

      Object.keys(els.steps).forEach(function (key) {
        if (els.steps[key]) els.steps[key].hidden = state.step !== key;
      });

      if (els.back) {
        els.back.hidden = state.step === 'packaging';
        els.back.textContent = 'Back';
      }
      if (els.next) {
        els.next.disabled = adding;
        els.next.textContent = adding ? (config.addingLabel || 'Adding…') : nextLabel();
      }
      if (els.summaryItems) {
        els.summaryItems.textContent = String(itemCount());
      }
      if (els.summaryTotal) els.summaryTotal.innerHTML = formatMoney(totalCents());

      renderProgress();
      renderCards();
      renderCount();
      renderPersonalize();
      renderReview();
      renderComplete();
      renderActionItems();
    }
  });
})();
